import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

@Component({
  selector: 'app-scheduled-report-page',
  templateUrl: './scheduled-report-page.component.html',
  styleUrls: ['./scheduled-report-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, RktIconComponent],
})
export class ScheduledReportPageComponent {
  constructor(private router: Router) {}

  viewReports() {
    this.router.navigate(['app/insights/documents']);
  }

  closeModal() {
    this.router.navigate(['app/insights']);
  }
}
